export default class StepFlowStrategyManager {
  constructor(options) {
    this._strategy = null;
    this._context = options;
  }

  set strategy(strategy) {
    this._strategy = strategy;
  }

  get strategy() {
    return this._strategy;
  }

  calculateSteps(flow) {
    return this._strategy.calculateSteps(this._context, flow);
  }
}

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pi1-1QAAT.scss');